const menus = [
  {
    id: 1,
    descricaoMenu: 'Equities',
    referenciaMenu: 'equities',
    tiposOperacao: [
      {
        id: 'prateleira',
        descricao: 'Prateleira',
      },
      {
        id: 'exclusiva',
        descricao: 'Exclusivas',
      },
    ],
  },
  {
    id: 2,
    descricaoMenu: 'FX',
    referenciaMenu: 'fx',
    tiposOperacao: [
      {
        id: 'prateleira',
        descricao: 'Prateleira',
      },
      {
        id: 'exclusiva',
        descricao: 'Exclusivas',
      },
    ],
  },
  {
    id: 3,
    descricaoMenu: 'Commodities',
    referenciaMenu: 'commodities',
    tiposOperacao: [
      {
        id: 'prateleira',
        descricao: 'Prateleira',
      },
      {
        id: 'exclusiva',
        descricao: 'Exclusivas',
      },
    ],
  },
  {
    id: 4,
    descricaoMenu: 'Juros',
    referenciaMenu: 'juros',
    tiposOperacao: [
      {
        id: 'prateleira',
        descricao: 'Prateleira',
      },
      {
        id: 'exclusiva',
        descricao: 'Exclusivas',
      },
    ],
  },
  {
    id: 5,
    descricaoMenu: 'Índices',
    referenciaMenu: 'indices',
    tiposOperacao: [
      {
        id: 'prateleira',
        descricao: 'Prateleira',
      },
      {
        id: 'exclusiva',
        descricao: 'Exclusivas',
      },
    ],
  },
  {
    id: 6,
    descricaoMenu: 'Novas Operações',
    referenciaMenu: 'novasoperacoes',
    tiposOperacao: [
      {
        id: 'prateleira',
        descricao: 'Prateleira',
      },
      {
        id: 'exclusivas',
        descricao: 'Exclusivas',
      },
    ],
  },
];

export default menus;
